export const INFO = 1;
export const WARN = 2;
export const DANGER = 3;
